module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Bold.3c726c52.ttf";